import { Button, Box as MuiBox, Typography } from '@mui/material';
import {
  FormTextField,
  Icon,
  DatePicker,
  FormChipRadioButton,
} from 'components/ui';
import { SBox, SFormControl, STextField } from './styled';
import Upload from '../components/UploadFile';
import { useTranslation } from 'react-i18next';
import { values } from 'ramda';
import { sexData } from 'lib/enums/sex';

export default function GeneralInfo({
  formValues,
  onRemoveFirstName,
  onAddFirstName,
  form,
  isBirthDateRequired = true,
  hideMiddleName = false,
}) {
  const { t } = useTranslation();
  return (
    <MuiBox style={{ display: 'flex' }}>
      <Upload name="photo" style={{ flex: 1 }} />
      <MuiBox width={'100%'} flex={2}>
        <MuiBox style={{ display: 'flex', gap: 30 }}>
          <SBox>
            {/* Always a list of given names (INSi models a list of prénoms);
                labelled "First name(s)" to make the multi-value nature clear. */}
            <SFormControl label={t('First name(s)') + ' *'}>
              {formValues?.name?.firstName?.map((item, idx) => (
                <FormTextField
                  dataId="first-name-input"
                  name={`name.firstName[${idx}]`}
                  placeholder={t('First name')}
                  withDeleteButton={!!idx}
                  onDelete={() => onRemoveFirstName(form, idx)}
                />
              ))}
              <Button
                style={{ width: 'fit-content' }}
                onClick={() => onAddFirstName(form)}
              >
                {'+ ' + t('Add name')}
              </Button>
            </SFormControl>
          </SBox>

          {/* "Middle name" is an Anglo concept with no INSi equivalent (INSi
              uses the prénom list) — hidden on INSi workspaces. */}
          {!hideMiddleName && (
            <SBox>
              <SFormControl label={t('Middle name')}>
                <FormTextField
                  dataId="first-name-input"
                  name="name.middleName"
                  placeholder={t('Middle name')}
                />
              </SFormControl>
            </SBox>
          )}
        </MuiBox>

        <MuiBox style={{ display: 'flex', gap: 30 }}>
          <SBox flex={1}>
            <SFormControl label={t('Last name') + ' *'}>
              <STextField
                dataId="last-name-input"
                name="name.lastName"
                placeholder={t('Last name')}
              />
            </SFormControl>
          </SBox>

          <SBox flex={1}>
            <SFormControl label={t('Suffix')}>
              <STextField
                dataId="suffix-input"
                name="name.suffix"
                placeholder={t('Suffix')}
              />
            </SFormControl>
          </SBox>
        </MuiBox>
        <MuiBox style={{ display: 'flex', gap: 30 }}>
          <SFormControl>
            <Typography variant="h5">
              {t('Date of birth') + (isBirthDateRequired ? ' *' : '')}
            </Typography>
            <DatePicker
              name="birthDate"
              dataId="date-picker-dialog"
              id="date-picker-dialog"
              placeholder={t('Date of birth')}
              openTo="year"
              disableFuture={true}
            />
          </SFormControl>

          <SFormControl label={t('Birth sex')}>
            <MuiBox
              display="flex"
              alignItems="center"
              // justifyContent="space-between"
              width="100%"
              gap="10px"
            >
              {values(sexData).map((item, index) => (
                <FormChipRadioButton
                  key={index}
                  name="gender"
                  $rounded={false}
                  dataId={`radio-button-${item.value}`}
                  value={item.value}
                  icon={
                    <Icon
                      icon={item.icon}
                      style={{ height: 25, width: 25, margin: 0 }}
                    />
                  }
                />
              ))}
            </MuiBox>
          </SFormControl>
        </MuiBox>
      </MuiBox>
    </MuiBox>
  );
}
